import { getCollectionId, getCollectionIdsFromCollection } from '@candu-ai/collections/utils';
import { useEditor } from 'craft/hooks';

export const useCollectionsFromContext = (nodeIds: string[]) => {
  const { query } = useEditor();

  // we retrieve all collection found in tree
  const collectionNodes = getCollectionId(nodeIds.length > 0 ? nodeIds[0] : undefined, query);
  return getCollectionIdsFromCollection(collectionNodes, query) as string[];
};
